import { classifyLead, HIGHLIGHT } from "../utils/classifyLead";

export const DigitalLeadRow = ({ lead, index, onAddRemarkClick }) => {
  const { id, name, phone, metadata, feedback } = lead;

  return (
    <>
      <tr key={id} className={index % 2 ? "bg-slate-800" : "bg-slate-900"}>
        <td className="p-2 text-center">{name}</td>
        <td className="p-2 text-center">{metadata.model}</td>
        <td className="p-2 text-center capitalize">{metadata.source}</td>
        <td className="p-2 text-center">
          <span
            className={`text-xs px-2 py-1 rounded-full font-bold inline-block ${
              HIGHLIGHT[classifyLead(feedback)]
            }`}
          >
            {classifyLead(feedback)}
          </span>
        </td>
        <td className="p-2 text-center capitalize">{phone}</td>

        <td className="p-2 text-center capitalize">{feedback.test_drive}</td>
        <td className="p-2 text-center">
          <button
            onClick={onAddRemarkClick}
            className="text-white font-montserrat text-xs bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg px-2 py-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
          >
            Add Remark
          </button>
        </td>
      </tr>
    </>
  );
};
